export default {
  login: {
    wrong_password: "Неверный пароль",
    enter_email: "Введите адрес электронной почты",
  },

  about: {
    version: "Версия",
    about_system: "Рекомендуется использовать браузер для работы с системой",
    display_resolution: "Разрешение дисплея",
    package_details: "Данные подписки",
    remaining_valid_days: "Оставшиеся дни действия:",
    remaining_device_count: "Оставшееся количество устройств:",
    no_used: "Использовано:",
    total_no_limit: "Общий лимит:",
  },

  company: {
    company_profile: "Профиль компании",
    name: "Наименование:",
    code: "Код:",
    phone: "Телефон:",
    email: "Электронная почта:",
    first_name: "Имя:",
    last_name: "Фамилия:",
    mobile_number: "Мобильный номер:",
    city: "Город:",
    country: "Страна:",
    address: "Адрес:",
    mobile: "Мобильный телефон:",
    state: "Регион/Область:",
  },

  retail_client: {
    add_retail_client: "Добавить розничного клиента",
    edit_retail_client: "Редактировать розничного клиента",
    view_retail_client: "Просмотреть розничного клиента",
    retail_client_name: "Название розничного клиента",
    retail_client_code: "Код розничного клиента",
    retail_admin_email: "Почта администратора клиента",
    retail_client_first_name: "Имя администратора",
    retail_client_last_name: "Фамилия администратора",
    number_of_devices: "Количество устройств",
    subscription_start_date: "Дата начала подписки",
    subscription_expire_date: "Дата окончания подписки",
    select_one_retail: "Выберите розничного клиента для работы",
  },

  template: {
    view_template: "Просмотреть шаблон",
    add_template: "Добавить шаблон",
    edit_template: "Редактировать шаблон",
    template_editor: "Редактор шаблонов",
    name: "Название шаблона",
    resolution: "Разрешение",
    type: "Тип шаблона",
    screen_direction: "Ориентация экрана ценника",
    preview: "Предпросмотр шаблона",
    screen_model: "Модель электронного ценника",
    is_bind_device: "Привязать шлюз",
  },

  editor: {
    product_element: "Элемент товара",
    price_pule: "Правило ценообразования",
    product_price: "Цена товара",
    product_label: "Товарная этикетка",
    quantity: "Количество",
    category1: "Категория 1 уровня",
    category2: "Категория 2 уровня",
    currency: "Валюта",
    origin: "Страна происхождения",
    manufacturer: "Производитель",
    discount_price: "Цена со скидкой",
    barcode: "Штрихкод",
    company_logo: "Логотип компании",
    basic_tags: "Базовые элементы",
    image_library: "Библиотека изображений",
    change_rule: "Правило изменения",
    free_text: "Свободный текст",
    add_label: "Добавить надпись",
    add_shape: "Добавить фигуру",
    delete_element: "Удалить элемент",
    rounded_corners: "Скругление углов:",
    content_example: "Пример отображения",
    bgcolor: "Цвет фона:",
    show_border: "Показать рамку:",
    show_scale: "Показать масштаб:",
    show_value: "Показать значение:",
    font_color: "Цвет шрифта:",
    font_size: "Размер шрифта:",
    font_style: "Стиль шрифта",
    font_weight: "Насыщенность шрифта:",
    font: "Шрифт:",
    spacing: "Межстрочный интервал:",
    rotation_angle: "Угол поворота:",
    width: "Ширина:",
    height: "Высота:",
    opacity: "Прозрачность:",
    line_color: "Цвет линии:",
    foreground_color: "Цвет переднего плана:",
    level: "Уровень",
    color: "Цвет",
    shape: "Фигура",
    line_height: "Высота строки",
    content: "Содержимое",
    qrcode: "QR-код",
    image: "Изображение",
    textBox: "Текстовое поле",
  },

  openAPI: {
    open_api_client: "Клиент открытого API",
    add_open_api: "Добавить клиент открытого API",
    secret_key: "Секретный ключ",
  },

  picture_library: {
    picture_library: "Библиотека изображений",
    add_picture: "Загрузить изображение",
    edit_picture: "Редактировать изображение",
    name: "Название изображения",
    id: "ID изображения",
    preview: "Предпросмотр изображения",
    type: "Тип изображения",
    size: "Размер изображения",
    progressing: "Обработка изображения",
    general_user: "Общее использование",
    company_logo: "Логотип компании",
    original_image: "Исходное изображение",
    dithering_image: "Дизеризованное изображение",
  },

  dashboard: {
    welcome_back: "С возвращением!",
    login_for_next: "Срок подписки истек, войдите для продления",
    days_only: "дней осталось",
    subscription_expires: "Срок действия подписки истекает",
    title: "Панель мониторинга NuTag",
    from_date: "Дата начала периода",
    period: "Период",
    registered_gateway: "Зарегистрированные шлюзы",
    registered_ESL: "Зарегистрированные электронные ценники",
    gateway_online_status: "Статус подключения шлюзов",
    last_refreshed: "Последнее обновление",
    refresh_success_rate: "Процент успешных обновлений",
    total_refreshes: "Всего обновлений",
    total_number: "Общее количество обновлений ценников за выбранный период",
    refreshes: "ОБНОВЛЕНИЯ",
    devices_distribution: "Распределение устройств",
    esl_total_stores: "Количество точек с ценниками / Всего торговых точек",
    esl_stores: "Точки с установленными ценниками",
    total_stores: "Все торговые точки",
    refresh_events: "События обновления",
    time_in_hours: "Время (часы)",
    refresh_time: "Количество обновлений",
    success_rate: "Процент успеха",
    day: "День",
    store: "ТОЧКА",
    all_stores: "ВСЕ ТОЧКИ",
    apply_filters: "ПРИМЕНИТЬ ФИЛЬТРЫ",
    period_from_date: "НАЧАЛО ПЕРИОДА",
    stores_installed: "Оборудованные точки",
    period_to_date: "КОНЕЦ ПЕРИОДА",
    select_store: "Выберите торговую точку",
  },

  authorization: {
    title: "Уровень прав доступа",
    add: "Добавить уровень прав",
    edit: "Редактировать уровень прав",
    view: "Просмотреть уровень прав",
    name: "Название уровня прав",
    list: "Список уровней прав",
  },

  product: {
    title: "Информация о товарах",
    add_product_label: "Добавить товарную этикетку",
    sku: "Артикул товара",
    category_level1: "Категория 1 уровня",
    category_level2: "Категория 2 уровня",
    category_level3: "Категория 3 уровня",
    currency_symbol: "Символ валюты",
    brand_name: "Название бренда",
    origin_of_product: "Страна происхождения товара",
    product: "Товар",
    add_product: "Добавить товар",
    view_product: "Просмотреть товар",
    edit_product: "Редактировать товар",
    product_picture: "Изображение товара",
    product_price: "Цена товара",
    discount_price: "Цена со скидкой",
    serial_number: "№ п/п",
    number_one: "1",
    coca_cola: "Coca Cola",
    drink: "Напиток",
    cold_drink: "Холодный напиток",
    number_two: "2",
    model: "Модель:",
    inc_screen_iD: "ID электронного ценника:",
    position_no: "Номер позиции:",
    resolution: "Разрешение:",
    add_success: "Добавлено успешно",
    rgb_settins: "Настройки RGB подсветки",
    please_select_light: "Выберите цвет подсветки",
    select_product: "Выберите товар",
    total_work_time: "Общее время работы LED подсветки (мин)",
    duration_time: "Укажите время работы",
    color_rgba: "Цвет RGB подсветки",
  },

  outlet: {
    title: "Торговая точка",
    add_outlet: "Добавить торговую точку",
    edit_outlet: "Редактировать торговую точку",
    view_outlet: "Просмотреть торговую точку",
    name: "Название торговой точки",
    code: "Код торговой точки",
    selected_outlet: "Точки выбраны",
  },

  user: {
    name: "Пользователь",
    person_list: "Список пользователей",
    create_person: "Создать пользователя",
    edit_person: "Редактировать пользователя",
    view_person: "Просмотреть пользователя",
    person_name: "Имя пользователя",
    person_Id: "ID пользователя",
    user_profile: "Профиль пользователя",
    person_avatar: "Аватар пользователя",
  },

  gateway: {
    gateway: "Шлюз",
    viewDeviceDetails: "Просмотреть данные устройства",
    addDeviceToOutlet: "Добавить устройство в точку",
    bindDeviceToOutlet: "Привязать устройство к точке",
    gatewaySerialNumber: "Серийный номер шлюза",
    gatewayName: "Название шлюза",
    gatewayIPAddress: "IP-адрес шлюза",
    gatewayFirmware: "Прошивка шлюза",
    gatewayRunningStatus: "Статус работы шлюза",
    gatewayUpdateTime: "Время последнего обновления шлюза",
    outlet: "Торговая точка",
    outletTimeZone: "Часовой пояс точки",
    versionNumber: "Номер версии",
    gatewayType: "Тип шлюза",
    gatewayModel: "Модель шлюза",
    outletCode: "Код торговой точки",
    logTime: "Время записи лога",
    logType: "Тип лога",
    logCode: "Код лога",
    enable: "Включить",
    deviceName: "Название устройства",
    deviceModel: "Модель устройства",
    serialNumber: "Серийный номер",
    deviceType: "Тип устройства",
    outletId: "ID торговой точки",
    clientName: "Название клиента",
    deviceLog: "Журнал устройства",
    view_gateway_details: "Просмотреть данные шлюза",
    select_version: "Выберите версию",
    enter_change: "Введите число, являющееся степенью двойки, диапазон: 2~65536",
    ground_value: "Значения групп — степени двойки, максимум 65536",
  },

  screen: {
    edit_screen: "Редактировать электронный ценник",
    bind_to_screen: "Привязать данные к ценнику",
    screenId: "ID электронного ценника",
    screen_resolution: "Разрешение ценника",
    positionNo: "Номер позиции",
    screenName: "Название ценника",
    powerStatus: "Состояние питания",
    gateway: "Шлюз",
    outlet: "Торговая точка",
    bindToProduct: "Привязать к товару",
    templatePreview: "Предпросмотр шаблона",

    screenStatus: "Статус ценника",
    screenUpdateTime: "Время обновления ценника",
    gatewaySerialNumber: "Серийный номер шлюза",
    gatewayName: "Название шлюза",
    deviceModel: "Модель устройства",
    deviceType: "Тип устройства",
    gatewayRunningStatus: "Статус работы шлюза",
    unbindDevice: "Отвязать устройство",

    bindData: "Привязать данные",
    normal: "Нормальный режим",
    lowPower: "Экономичный режим",
    total: "Всего",
    unbound_templates: "Непривязанные шаблоны",
    batchUpdateScreen: "Массовое редактирование ценников",
    same_screen: "Выберите ценники с одинаковым разрешением",
    is_bindDevice: "Укажите, нужно ли привязать устройство",
    same_advgroup: "Рекламная группа ценника не совпадает с группой шлюза",
    upgrade_device: "Список устройств для обновления",
    enter_valid_number: "Введите корректное число",
    please_enter: "Укажите общее время работы LED подсветки (минуты)",
    select_online_screen: "Выберите онлайн-электронный ценник",
  },

  events: {
    price_Change_Events: "События изменения цен",
    add_priceChangeEvent: "Создать событие изменения цен",
    edit_priceChangeEvent: "Редактировать событие изменения цен",
    view_priceChangeEvent: "Просмотреть событие изменения цен",
    priceChangeName: "Название события изменения цен",
    priceChangeRule: "Правило изменения цен",
    templateName: "Название шаблона",
    scheduleTime: "Расписание",
    approvalStatus: "Статус согласования",
    areaFilter: "Фильтр по регионам",
    outlet: "Торговая точка",
    productFilter: "Фильтр по товарам",
    productElement: "Элемент товара",
    brand: "Бренд",
    promotionType: "Тип акции",
    templateSelection: "Выбор шаблона",
    selectTemplate: "Выберите шаблон для данного события изменения цен",
    schedule: "Расписание",
    scheduleMode: "Режим расписания",
    timeZone: "Часовой пояс",
    startPromotion: "Начало акции",
    endPromotion: "Окончание акции",
    doesNotEnd: "Без даты окончания",
    setRepeatCondition: "Настроить повтор",
    immediateSync: "Синхронизация сразу",
    startTime: "Время начала",
    endTime: "Время окончания",
    validYear: "Год действия",
    validMonth: "Месяц действия",
    validDate: "Дата действия",
    startDate: "Дата начала",
    endDate: "Дата окончания",
    days: "Дни недели",
    dates: "Конкретные даты",
    allDay: "Весь день",
  },

  approval: {
    approvalList: "Список заявок на согласование",
    priceChangeDetails: "Данные события изменения цен",
    viewApprovalRequest: "Просмотреть заявку на согласование изменения цен",
    approvalEvent: "Событие согласования",
    maker: "Автор заявки",
    createTime: "Время создания",
    priceChangeName: "Название события изменения цен",
    productFilter: "Фильтр по товарам",
    priceChangeRule: "Правило изменения цен",
    priceChangeRuleName: "Название правила изменения цен",
    templateSelection: "Выбор шаблона",
    templateName: "Название шаблона",
    schedule: "Расписание",
    timeZone: "Часовой пояс",
    startTime: "Время начала",
    endTime: "Время окончания",
    setRepeatCondition: "Настроить повтор",
    includeExcludeDays: "Включить/исключить дни недели",
    approve: "Утвердить",
    reject: "Отклонить",
    rejectUpper: "ОТКЛОНИТЬ",
    approveUpper: "УТВЕРДИТЬ",
    approvalLog: "Журнал согласований",
    approvalLogEvent: "Событие согласования",
    approvalLogPerson: "Уполномоченное лицо",
    approvalLogApprovalTime: "Время согласования",
    approvalLogStatus: "Статус согласования",
  },

  synchronized: {
    systemRecords: "Системные записи",

    screenID: "ID электронного ценника",
    outlet: "Торговая точка",
    product: "Товар",
    deviceSN: "Серийный номер устройства",
    status: "Статус",
    picture: "Изображение",

    // 新增
    mobile: "Мобильный телефон",
    address: "Адрес",
    country: "Страна",
    stateProvince: "Регион/Область",
    city: "Город",
    noRecordFound: "Записи не найдены",
    clear: "Очистить",
    confirm: "Подтвердить",
    resendPriceEvent: "Повторно отправить событие изменения цен",
  },

  price: {
    promotiontype: "Выберите тип акции",
    number: "Введите число",
    maximum_discount: "Максимальный размер скидки — 100%",
    select_timezone: "Выберите часовой пояс",
    select_starttime: "Выберите время начала",
    select_time: "Выберите время",
    approved: "Утверждено",
    rejected: "Отклонено",
    deleted: "Удалено",
    last_template: "Последний использованный шаблон",
    select_times: "ВЫБЕРИТЕ ВРЕМЯ",
  },

  enum: {
    does_not_repeat: "Без повторений",
    daily: "Ежедневно",
    weekly: "Еженедельно",
    monthly: "Ежемесячно",
    annually: "Ежегодно",
  },


  login_log: {
    title: "Журнал входов",
    login_msg: "Событие входа",
    access_time: "Время входа",
    address: "Адрес входа",
    ipaddr: "IP-адрес входа",
    account: "Учетная запись",
    user_name: "Имя пользователя",
    ipaddr_tip: "Введите IP-адрес",
    user_name: "Имя пользователя",
    user_name_tip: "Введите имя пользователя",
  },


  operation_log: {
    title: "Журнал операций",

    // User management operations
    server_person_add: "Добавить пользователя",
    server_person_edit: "Редактировать пользователя",
    server_person_delete: "Удалить пользователя",
    server_send_email: "Отправить письмо",

    // Gateway operations
    server_device_add: "Добавить шлюз",
    server_device_delete: "Удалить шлюз",
    server_device_advgroup: "Рекламная группа электронных ценников",

    // Price tag operations
    server_screen_edit: "Редактировать электронный ценник",
    server_screen_led_control: "Управление подсветкой",
    server_template_post: "Привязать данные",

    // Price change event operations
    server_price_change_event_add: "Создать событие изменения цен",
    server_price_change_event_edit: "Редактировать событие изменения цен",
    server_price_change_event_delete: "Удалить событие изменения цен",

    // Approval operations
    server_approval_status: "Статус согласования",

    // Sync log operations
    server_screen_resend: "Повторно отправить событие изменения цен",

    preview_title: "Предпросмотр журнала операций",
    method: "Тип операции",
    account: "Учетная запись оператора",
    ipAddr: "IP-адрес оператора",
    address: "Адрес оператора",
    operationTime: "Время выполнения операции",
    status: "Статус операции",
    accountName: "Учетная запись оператора",
    accountNameTip: "Введите учетную запись",
    ipAddrName: "IP-адрес оператора",
    ipAddrNameTip: "Введите IP-адрес",
    addressName: "Адрес оператора",
    addressName: "Введите адрес",
    user_name: "Имя пользователя",
    operation_method: "Тип операции",
    operation_time: "Время операции",
    operation_ipaddr: "IP-адрес операции",
    operation_execute_time: "Время выполнения",
    operation_message: "Описание операции",
    operation_status: "Статус операции",
    browser: "Браузер",
    system: "Система",
    server_client_add: "Добавить розничного клиента",
    server_client_edit: "Редактировать розничного клиента",
    server_client_delete: "Удалить розничного клиента",
    server_template_add: "Добавить шаблон",
    server_template_edit: "Редактировать шаблон",
    server_template_delete: "Удалить шаблон",
    server_third_party_app_add: "Добавить клиент API",
    server_picture_library_add: "Загрузить изображение",
    server_picture_library_edit: "Редактировать изображение",
    server_picture_library_delete: "Удалить изображение",
    server_mobile_version_add: "Добавить мобильное приложение",
    server_mobile_version_edit: "Редактировать мобильное приложение",
    server_mobile_version_delete: "Удалить мобильное приложение",
    server_role_add: "Добавить группу прав",
    server_role_edit: "Редактировать группу прав",
    server_role_delete: "Удалить группу прав",
    server_approval_add: "Добавить процесс согласования",
    server_approval_edit: "Редактировать процесс согласования",
    server_approval_delete: "Удалить процесс согласования",
    server_attribute_add: "Добавить данные товара",
    server_attribute_delete: "Удалить данные товара",
    server_outlet_add: "Добавить торговую точку",
    server_outlet_edit: "Редактировать торговую точку",
    server_outlet_delete: "Удалить торговую точку",
    server_product_add: "Добавить товар",
    server_product_edit: "Редактировать товар",
    server_product_delete: "Удалить товар",
    server_product_upload: "Загрузить файл",
    server_product_led_control: "Управление подсветкой",
  },
};
